import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=c978c306&scoped=true&"
import script from "./TopBanner.vue?vue&type=script&lang=ts&"
export * from "./TopBanner.vue?vue&type=script&lang=ts&"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=c978c306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c978c306",
  null
  
)

export default component.exports